module.exports = __webpack_public_path__ + "static/media/document.db641dbe.png";